import React, { useState } from 'react';
import '../css/brochure.css';
import contact from '../../../../data/layouts/contact';
import { Link } from 'react-router-dom';

const Brochure = ({ data }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showMore, setShowMore] = useState(false);
  return (
    <section
      className="brochure m-0 py-5 lazy-bg skeleton loaded"
      id="brochure"
      style={{
        backgroundImage: 'url("./images/Section02-01-8.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="right-bg">
        <div className="container">
          <div className="wrap">
            <div className="row">
              <div className="brochure-left col-lg-6 col-12">
                <div className="brochure-video mt-lg-5 mb-3 lazy-bg skeleton loaded">
                  {!isPlaying ? (
                    <div
                      className="video-thumbnail"
                      style={{
                        backgroundImage: `url("${data?.imageUrl}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}
                      onClick={() => setIsPlaying(true)}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          background: 'rgba(0, 0, 0, 0.6)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          src="/images/icons/play.png"
                          alt="Play icon"
                          loading="lazy"
                          style={{
                            width: '50px',
                            height: '50px',
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <iframe
                      className="video-thumbnail"
                      src={data.videoUrl}
                      title={data.title}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  )}
                </div>
              </div>
              <div className=" brochure-right col-lg-6 col-12">
                <div className="ps-lg-5 ms-lg-3 right">
                  <h1
                    className="default-box-title"
                    style={{ fontFamily: 'var(--font-family-open-sans)' }}
                  >
                    {contact.name}
                  </h1>
                  <p className="slogan">
                    <strong>
                      Tập đoàn làm sạch tòa nhà văn phòng chuyên nghiệp Top 1
                      Việt nam
                    </strong>
                  </p>
                  <div className="larry-page-quote position-relative">
                    <div className="quote">
                      “Công ty Cổ phần Thành Đồng Group tự hào là một trong
                      những doanh nghiệp tiên phong tại Việt Nam, chuyên cung
                      cấp các giải pháp Xanh - Sạch - Đẹp hướng tới sự phát
                      triển bền vững. Với tầm nhìn rõ ràng và sứ mệnh đầy trách
                      nhiệm, chúng tôi không chỉ mang đến các sản phẩm và dịch
                      vụ chất lượng cao mà còn góp phần xây dựng một môi trường
                      sống trong lành cho cộng đồng.”
                    </div>
                    <strong className="position-absolute">
                      Thành Đồng Group
                    </strong>
                  </div>
                  <div className="mb-3 text">
                    Thành Đồng Group đặt nền tảng phát triển trên ba giá trị cốt
                    lõi: Tận tâm - Khát khao - Chuyên nghiệp. Đó là sự tận tâm
                    trong từng giải pháp, sự uy tín trong từng cam kết và chất
                    lượng vượt trội trong mọi dịch vụ. Từ cây xanh văn phòng,
                    đến vệ sinh hàng ngày và Bảo trì chống thấm, chúng tôi mang
                    đến những trải nghiệm khác biệt, vừa thiết thực, vừa ý
                    nghĩa.
                    {showMore && (
                      <>
                        <br />
                        <br />
                        Bằng sự sáng tạo và không ngừng đổi mới, Thành Đồng
                        Group đã, đang và sẽ tiếp tục khẳng định vị thế của mình
                        trên hành trình xanh hóa cuộc sống, Sạch hóa văn phòng,
                        đồng hành cùng khách hàng và đối tác để hướng tới một
                        tương lai bền vững.
                      </>
                    )}
                  </div>
                  <div>
                    <Link
                      to="#"
                      title=""
                      className="detail me-2"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMore(!showMore);
                      }}
                    >
                      {showMore ? 'Ẩn bớt' : 'Xem chi tiết'}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brochure;
